import { Color } from "three"

export const desert = new Color(0xf4a460) // Sandy brown
export const grass = new Color(0x228b22) // Green // first green

// desert colors
// A soft, sunlit beige representing sun-bleached desert sand
export const duneTan = new Color(0xD8B071)

// A mid-tone orange-brown ideal for dry, compact ground in desert maps
export const dustyOchre = new Color(0xC98A3F)

// A deeper rust hue for rocky or shaded terrain areas
export const burntClay = new Color(0xA45E32)

// A light sandy yellow used for highlights or fine dunes
export const paleAlmond = new Color(0xE8D3A0)

// A muted, dark brown perfect for shadows, trenches, or weathered roads
export const desertShadow = new Color(0x6E4A2F)

// Earthy brown with slight mossy tone
export const forestFloorOld = new Color(0x4C3E30)
// export const forestFloor = grass.clone().multiplyScalar(0.9)
export const forestFloor = grass.clone().lerp(forestFloorOld, 0.1)


// from the wargroove mockup
// export const grass = new Color(0x83b243) // Green
// export const grass = new Color(0x8ab141) // Green
// export const grass = new Color(0x99c34a) // Light Green
// export const grass = new Color(0x789f39) // Dark Green
// export const grass3 = new Color(0x64892f) // Shadow Green

export const sea = new Color(0x1e90ff) // Blue
export const debugPink = new Color(0xFF69B4) // Pink

// Ocean floor variations
export const oceanFloorDarkSand = new Color(0x8B7765) // Dark sandy brown
export const oceanFloorMuddyGrayBlue = new Color(0x5E676D) // Muddy gray-blue
export const oceanFloorGreenishBrown = new Color(0x4A5E50) // Dark greenish-brown (Algae-covered seabed)
export const oceanFloorDeepSlate = new Color(0x3E4C59) // Deep slate gray (Rocky, deep-sea terrain)

// Tropical shallow ocean floors
export const oceanFloorLightSand = new Color(0xC2B280) // Light sandy beige
export const oceanFloorMutedSeaGreen = new Color(0x5D737E) // Muted sea green

export const ridgeRockGray = new Color(0x6B6B6B) // Medium gray (Standard rock)
export const ridgeDarkRock = new Color(0x4B4B4B) // Dark, shadowed rock
export const ridgeSlate = new Color(0x556B6F) // Slate gray with a hint of blue
export const ridgeBasalt = new Color(0x3C3C3C) // Basalt (dark volcanic rock)
export const ridgeBrownRock = new Color(0x8B7355) // Weathered brown rock
export const ridgeSandstone = new Color(0xA99171) // Light sandstone

export const ridgeSnowCap = new Color(0xE0E0E0) // Light snow/ice
export const ridgeFrostGray = new Color(0xB0C4DE) // Frosty gray-blue
export const ridgeColdStone = new Color(0x6A7F8B) // Cold, high-altitude stone

export const ridgeClay = new Color(0x9E7B6B) // Clay brown
export const ridgeRedEarth = new Color(0x8B0000) // Deep red rock (like in deserts)
export const ridgeDirt = new Color(0x6B4F3F) // Dark brown dirt

// Marsh - Wet, muddy ground with decomposing vegetation
export const marshMud = new Color(0x5D4037) // Dark brown mud
export const marshPeat = new Color(0x4E3524) // Rich, dark organic matter

// Swamp - Dark, nutrient-rich wetland soil
export const swampMuck = new Color(0x3E2723) // Very dark brown/black soil
export const swampBog = new Color(0x4A342E) // Slightly lighter than muck, still very dark

// Lake - Deep, dark basin floor
export const lakeBed = new Color(0x37474F) // Deep blue-gray lake bottom
export const lakeSilt = new Color(0x455A64) // Lighter silty lake bottom

// Deadwood - Haunted forest floor
export const deadwoodGround = new Color(0x2C1810) // Dark, ashy soil
export const deadwoodAsh = new Color(0x3E2723) // Ashy gray-brown

// Jungle - Rich, dark soil with lots of organic matter
export const jungleFloor = new Color(0x1B5E20) // Dark greenish-brown
export const jungleSoil = new Color(0x2E7D32) // Slightly lighter greenish soil

export const ridgeAsh = new Color(0x505050) // Volcanic ash gray
export const ridgeLavaRock = new Color(0x3B2F2F) // Dark basalt or lava rock
export const ridgeCharred = new Color(0x2B2B2B) // Charred rock, almost black

// Light sand at the top of sand dunes (sunlit, dry)
export const sandDuneTop = new Color(0xF7DC8A)
// General beach sand (typical warm golden sand)
export const beachSand = new Color(0xF4D03F)
// Wet sand near the waterline (darker due to moisture)
export const wetSand = new Color(0xD4AC0D)
// Undersea sand (submerged, slightly muted in color)
export const underseaSand = new Color(0xB7950B)
// Deeper sea sand (darker, less light penetration)
export const deepSeaSand = new Color(0x7E5109)

// Silty brown — typical of muddy riverbeds
export const riverBasinSilt = new Color(0x8C7156) // #8C7156
// Wet stone gray — smooth rocks under flowing water
export const riverBasinWetStone = new Color(0x5F5C5A) // #5F5C5A
// Algae-stained green-brown — where water clings to organic matter
export const riverBasinAlgae = new Color(0x6A7752) // #6A7752
// Clay-rich tan — common in slow-moving riverbanks
export const riverBasinClay = new Color(0xB29873) // #B29873
// Cold bluish-gray — hints of water-shadowed gravel
export const riverBasinCoolGravel = new Color(0x6C747C) // #6C747C

// const ridgeColor = debugPink
// const ridgeColor = ridgeDirt


// Mountain colors
export const mountainRock1 = new Color(0x8b7355) // Rocky brown
export const mountainRock2 = new Color(0x6b4f3f) // Darker brown
export const mountainRock3 = new Color(0x4b3e26) // Darker, more weathered rock
export const mountainRock4 = new Color(0x3c2f2f) // Darkest, charred rock
export const mountainRock5 = new Color(0x2b2b2b) // Charred, almost black
